import barba from '@barba/core'

export default class CreateBarba {
	constructor() {
		this.barba = barba
	}

}
  